import styled from 'styled-components';
import Toolbar from '@material-ui/core/Toolbar';

const AppBarRow = styled(Toolbar)`
  display: flex;
  width: 100%;
  min-height: 48px;
`;

AppBarRow.defaultProps = {
  disableGutters: true,
  variant: 'dense',
};

AppBarRow.propTypes = { ...Toolbar.propTypes };

export default AppBarRow;
